/* eslint-disable prettier/prettier */
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AuthService from '../../Services/AuthService';
import LoadingBar from '../LoadingBar/LoadingBar';

const gT = (t, key) => t(`component-authorize-visma${key}`);

export default function AuthorizeVisma() {
  const { t } = useTranslation('app');
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    const decodeToken = async () => {
      const usp = new URLSearchParams(search);
      const error = usp.get('error');
      const authCode = usp.get('code');
      const state = usp.get('state');
      const errorDescription = usp.get('error_description');

      const stateParams = await AuthService.decode(state);
      const externalStateId = new URLSearchParams(stateParams).get('ext');

      let url = `/authorization?ext=${externalStateId}`;
      if (error === null) {
        if (authCode) {
          url += `&action=createClient&partnerId=2&authCode=${authCode}`;
        }
        history.push(url);
        return;
      }
      url += `&action=auth&error_type=accounting&error_description=${errorDescription}&partnerId=2`;
      await AuthService.updateOnboardingEvent(
        externalStateId,
        1,
        errorDescription
      );
      history.push(url);
    };
    decodeToken();
  }, [search, history]);
  return <LoadingBar active status={gT(t, '.loading-bar')} />;
}
